export default "__VITE_ASSET__CtWwI87g__"